module.exports = __webpack_public_path__ + "img/treccaniLogo.81d4e266.svg";